module.exports = __webpack_public_path__ + "img/13.999ef1a0.jpg";